import styles from './NotFoundPage.module.scss';
const NotFoundPage = () => {
  return (
    <div className={styles.NotFoundPage}>
      <h1>404</h1>
      <h2>Страница не найдена</h2>
      <p>Возможно, адрес ссылки не верный</p>
    </div>
  );
};

export default NotFoundPage;
